module.exports = __webpack_public_path__ + "e59a49640350d84fcffb8e34cf66e0a0.MP3";